module.exports = __webpack_public_path__ + "img/template-dne-market-03.a4545d74.jpg";